/* eslint-disable @typescript-eslint/no-explicit-any */
export type KeyArrayValuePair = {
  keys: string[]
  value: string
}

export const getAllKeyValuePairs = (obj: any, currentPath: string[] = [], result: KeyArrayValuePair[] = []) => {
  Object.keys(obj).forEach((key) => {
    const newPath = [...currentPath, key]

    if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
      getAllKeyValuePairs(obj[key], newPath, result)
    } else {
      result.push({ keys: newPath, value: obj[key] })
    }
  })

  return result
}

export const parseValue = (obj: any) => {
  let value
  try {
    value = JSON.stringify(obj, null, 2)
  } catch (e) {
    value = obj.toString()
  }
  if (value.startsWith('"') && value.endsWith('"')) {
    return value.substring(1, value.length - 1)
  }
  return value
}

export const getQueryStatement = (keyArrayValuePair: KeyArrayValuePair) => {
  const newQuery: string[] = []

  const keys = keyArrayValuePair.keys

  if (keys.length === 1) {
    return `${keys[0]}:${parseValue(keyArrayValuePair.value)}`
  }

  keys.forEach((key) => {
    if (key.match(/\./)) newQuery.push(`[${key}]`)
    else newQuery.push(`${key}`)
  })

  const statement = newQuery.join('.').replace(/\.\[/, '[') + `:'${parseValue(keyArrayValuePair.value)}'`

  return statement
}
